import sanitizeHtml from 'sanitize-html';
import i18n from 'src/features/i18n';

export default function notificationsRegister(message) {
  const title = i18n.t('T_NEW_MESSAGE');
  const sanitizeMessage = sanitizeHtml(message, {
    allowedTags: null,
  }).replace(/[<>/]/ig, () => ' ').replace(/\s+/g, ' ').trim();

  const options = {
    body: sanitizeMessage,
  };
  if ('Notification' in window) {
    if (Notification.permission === 'granted') {
      return new Notification(title, options);
    }
    if (Notification.permission !== 'denied') {
      Notification.requestPermission((permission) => {
        if (!('permission' in Notification)) {
          Notification.permission = permission;
        }
        if (permission === 'granted') {
          return new Notification(title, options);
        }
        return this;
      });
    }
  }
  return this;
}
